import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import ServicesGrid from "./sections/ServicesGrid";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <HeroSection />
      <ServicesGrid />
      <Footer />
    </div>;
}